"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALIDATOR_OK_STATUSES = void 0;
const RESOURCE_IS_VALID = 200;
const RESOURCE_HAS_ISSUES = 422;
const RESOURCE_NOT_FOUND = 404;
const DEPRECATED_RESOURCE_HAS_ISSUES = 400;
exports.VALIDATOR_OK_STATUSES = [
    RESOURCE_IS_VALID,
    RESOURCE_HAS_ISSUES,
    RESOURCE_NOT_FOUND,
    DEPRECATED_RESOURCE_HAS_ISSUES
];
//# sourceMappingURL=index.js.map